export {
  default as plunge,
  ReactComponent as Plunge,
} from '@assets/icons/search/filters/plunge.svg'    
